<template>
  <div v-if="series && series.length" class="card my-2">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-lg-12">
          <div class="cui__utils__heading mb-0">
            <strong>Number of messages <br />per channel</strong>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" style="text-align: center">
      <apex-chart
        v-if="!$parent.loading"
        type="bar"
        :options="options"
        :series="series"
      ></apex-chart>
      <a-skeleton active v-else />
    </div>
  </div>
</template>

<script>
import apexChart from 'vue-apexcharts'
import common from '@/utils/analytics/common'
import { Skeleton } from 'vue-loading-skeleton'
export default {
  name: 'messages-per-session',
  components: {
    apexChart,
    ASkeleton: Skeleton
  },
  props: {
    channels: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      options: {
        chart: {
          id: 'avg-msg-per-session'
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          title: {
            text: 'Message / Interaction'
          }
        }
      },
      series: []
    }
  },
  watch: {
    channels: {
      deep: true,
      immediate: true,
      handler(val) {
        // this.series[0] = {
        //     name: 'Bot',
        //     data: []
        // };

        // this.series[1] = {
        //     name: 'User',
        //     data: []
        // };

        // let categories = [];
        // for (let i=0; i<this.channels.length; i++) {
        //     this.series[0].data.push(Number(this.channels[i].data.avg_bot_msgs.toFixed(2)))
        //     this.series[1].data.push(Number(this.channels[i].data.avg_user_msgs.toFixed(2)))
        //     categories.push(this.channels[i].name)
        // };
        this.series = this.channels.map((c) => ({
          name: common.handleReceiverName(c.name).toUpperCase(),
          data: this.$_.sortBy(c.value, (s) => s.name).map((i) =>
            parseFloat(i.value, 10).toFixed(2)
          )
        }))
        // const categories = this.channels.length
        //   ? this.channels[0].value.map((c) => common.handleChannelName(c.name))
        //   : []
        let categories = []
        let temp = []
        let i
        for (i = 0; i < this.channels.length; i += 1) {
          temp = this.channels[i].value
            .filter((c) => categories.indexOf(c.name) === -1)
            .map((v) => v.name)
          categories = [...categories, ...temp]
        }
        categories = categories.sort().map((c) => common.handleChannelName(c))

        // const channels = this.channels.map((c) =>
        //   this.$_.sortBy(c.value, ['name'])
        // )

        this.options = {
          chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            toolbar: {
              show: true
            },
            zoom: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function (value) {
              return common.numberWithCommas(value)
            }
          },
          xaxis: {
            categories
          },
          yaxis: {
            title: {
              text: 'Number of Messages'
            },
            labels: {
              formatter(value) {
                return common.numberWithCommas(value)
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style src="@/assets/css/bs-helpers.css" lang="css" scoped/>
